/* cc-mega-nav — hover-intent open/close for the mega panel.
   Panels are reparented to <body>: inside the frosted header the
   backdrop-filter makes Chromium composite them ghosted, and it is
   the containing block for fixed descendants (cc-burger-panel lesson).
   Opens on pointer hover (120ms intent) or focus; closes on leave
   (200ms grace), Escape, or outside click. One panel at a time. */

(() => {
  const items = document.querySelectorAll('.cc-mega-nav__item--mega');
  if (!items.length) return;

  let openItem = null;
  const pairs = new Map(); // item -> { link, panel }

  items.forEach((item) => {
    const panel = item.querySelector('.cc-mega-nav__panel');
    pairs.set(item, { link: item.querySelector('.cc-mega-nav__link'), panel });
    document.body.appendChild(panel);
  });

  function close(item) {
    if (!item) return;
    const { link, panel } = pairs.get(item);
    item.classList.remove('cc-mega-nav__item--open');
    panel.classList.remove('cc-mega-nav__panel--open');
    link.setAttribute('aria-expanded', 'false');
    setTimeout(() => {
      if (!panel.classList.contains('cc-mega-nav__panel--open')) panel.hidden = true;
    }, 250); // after exit transition
    if (openItem === item) openItem = null;
  }

  function open(item) {
    if (openItem && openItem !== item) close(openItem);
    const { link, panel } = pairs.get(item);
    const header = document.querySelector('.header-wrapper');
    if (header) {
      panel.style.setProperty('--cc-panel-top', Math.round(header.getBoundingClientRect().bottom) + 'px');
    }
    panel.hidden = false;
    requestAnimationFrame(() => {
      item.classList.add('cc-mega-nav__item--open');
      panel.classList.add('cc-mega-nav__panel--open');
      link.setAttribute('aria-expanded', 'true');
    });
    openItem = item;
  }

  pairs.forEach(({ panel }, item) => {
    let intent, grace;
    const enter = () => {
      clearTimeout(grace);
      intent = setTimeout(() => open(item), 120);
    };
    const leave = () => {
      clearTimeout(intent);
      grace = setTimeout(() => close(item), 200);
    };

    // Panel lives on <body>, so hover must be tracked on both halves
    [item, panel].forEach((el) => {
      el.addEventListener('mouseenter', enter);
      el.addEventListener('mouseleave', leave);
    });

    item.addEventListener('focusin', () => {
      clearTimeout(grace);
      open(item);
    });
    [item, panel].forEach((el) =>
      el.addEventListener('focusout', (e) => {
        if (!item.contains(e.relatedTarget) && !panel.contains(e.relatedTarget)) close(item);
      })
    );
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && openItem) close(openItem);
  });

  document.addEventListener('click', (e) => {
    if (!openItem) return;
    const { panel } = pairs.get(openItem);
    if (!openItem.contains(e.target) && !panel.contains(e.target)) close(openItem);
  });
})();
